// import concat from 'lodash/concat';
import CancelamentoAdesaoRouter from './cancelamentoadesao/routes';
import ComponenteUtilizacaoRouter from './componenteutilizacao/routes';
import IdentificacaoSaudeSuplementarRouter from './identificacaosaudesuplementar/routes';

const SAUDESUPLEMENTAR = () => import('./main.vue');

export default [
  {
    name: 'relatorio/saude-suplementar',
    path: '/relatorio/saude-suplementar',
    component: SAUDESUPLEMENTAR,
    meta: {
      requiresAuth: true,
      breadcrum: 'Portal de Informações do Beneficiário da Saúde Suplementar - PIN-SS',
      icon: 'folder-open',
      can: 'list',
      on: 'relatoriosaudesuplementar',
      neto: true,
    },
    children: [
      ...CancelamentoAdesaoRouter,
      ...ComponenteUtilizacaoRouter,
      ...IdentificacaoSaudeSuplementarRouter,
    ],
  },
];
